import { DatePicker } from "antd";
import momentGenerateConfig from "./config";
var MomentDatePicker = DatePicker.generatePicker(momentGenerateConfig);
export default MomentDatePicker;